import {SET_TABLE_DATA, SET_META_VALUE, ERROR, SET_ORDERING, GET_ORGANIZATIONS,
  GET_CATEGORIES, GET_MODULES, GET_SECTIONS, POST_MODULE, UPDATE_REMINDER, IS_LOADING, KEY_DATA_FLAG, DYAMIC_DSP_MAJ_SELECT, UPDATE_SUB_COL_HEADERS,
  GET_CATEGORY_DATA, GET_PRIORITY_STATUS, SET_GLYICON, GET_INSTITUTION_COUNT, GET_ORGID_ROLES, SELECT_ALL_COLUMNS,
  GET_OID, GET_ITEMS_SAVED, GET_ITEMS_BEING_SAVED, GET_UNSAVED_HEADERS,
  SET_MODULE_DATA, SET_LOADING_STATUS, GET_NEW_ROLES, GET_CDS_STATUS,
  SET_ALERT_MESSAGE, UPDATE_UNSAVED_MODULE, UPDATE_METADATA, CDS_FLAG, BFCP_HE_LOCK_DESCRIPTION, UPDATE_SEARCH_TERM, UPDATE_FEATURE_FLAG,
  SET_ORDERING_STATUS, SET_TRIGGER_MODULE_ID, SET_PUBLISH_CAT_ID, SET_PUBLISH_ERROR, SEL_SEARCH_VAL, SET_SAVE_STATUS
} from './types';

//REDUCER FOR rolestore
export const rolesReducer = (state, action) => {
  const {type, payload} = action;
  switch (type) {
    case GET_NEW_ROLES:
      return {...state, newroles:payload};
    case GET_INSTITUTION_COUNT:
      return {...state, institution:payload};
    case GET_OID:
      return {...state, uniqueoids:payload};
    case GET_ORGID_ROLES:
      return {...state, orgid_roles:payload};
    default:
      return state;
  }
};

// reducer used for Non Admins landing PAGE
export const dataReducer = (state, action) => {
  const {type, payload} = action;
  switch (type) {
    case SET_TABLE_DATA:
      return {...state, tableData:payload};
    case SET_ORDERING:
      return {...state, ordering:payload};
    case SET_ORDERING_STATUS:
      return {...state, orderingStatus:payload};
    case SET_META_VALUE:
      return {...state, metaValues:payload};
    case ERROR:
      return {errorMessage: payload};
    case IS_LOADING:
      return {loading: payload};
    case SET_GLYICON:
      return {glyicon: payload};
    default:
      return state;
  }
};

// data store reducers
export const storeReducer = (state, action) => {
  const {type, payload} = action;
  switch (type) {
    case GET_ORGANIZATIONS:
      return {
        ...state,
        orgData: payload};
    case GET_MODULES:
      return {...state, questionJson:payload};
    case GET_SECTIONS:
      return {...state, sectionJson:payload};
    case GET_CATEGORIES:
      return {...state, json:payload};
    case UPDATE_METADATA:
      return {...state, metaDataAboutUser: payload};
    case POST_MODULE:
      return {...state, json:payload};
    case UPDATE_REMINDER:
      return {...state, reminderData: payload};
    case KEY_DATA_FLAG:
      return {...state, key_data: payload};
    case CDS_FLAG:
      return {...state, cds: payload};
    case BFCP_HE_LOCK_DESCRIPTION:
      return {...state, bfcp_he_lock_description: payload};
    case SEL_SEARCH_VAL:
      return {...state, selSearchVal: payload};
    case DYAMIC_DSP_MAJ_SELECT:
      return {...state, dynamicDisplayMajors: payload};
    case SELECT_ALL_COLUMNS:
      return {...state, selecallcolumns: payload};
    case UPDATE_SUB_COL_HEADERS:
      return {...state, accordionMajorHeaders: payload};
    case UPDATE_SEARCH_TERM:
      return {...state, searchTerm: payload};
    case UPDATE_FEATURE_FLAG:
      return {...state, featureFlagStatus: payload};
    case ERROR:
      return {errorMessage: payload};
    default:
      return state;
  }
};

// category reducers
export const categoryReducer = (state, action) => {
  const {type, payload} = action;
  switch (type) {
    case GET_CATEGORY_DATA:
      return {...state, categoryData: payload};
    case GET_PRIORITY_STATUS:
      return {...state, highpriorityStatus: payload};
    case SET_PUBLISH_CAT_ID:
      return {...state, publishCatId: payload};
    case SET_PUBLISH_ERROR:
      return {...state, publishError: payload};
    case GET_CDS_STATUS:
      return {...state, cdsStatus: payload};
    case ERROR:
      return {errorMessage: payload};
    default:
      return state;
  }
};

//MODULE PAGE REDUCERS
export const modulePageReducer = (state, action) => {
  const {type, payload} = action;
  switch (type) {
    case SET_TRIGGER_MODULE_ID:
      return {...state, triggerModuleId: payload};
    case UPDATE_UNSAVED_MODULE:
      return {...state, unsavedModuleIds:payload};
    case SET_ALERT_MESSAGE:
      return {...state, alertMessage:payload};
    case SET_LOADING_STATUS:
      return {...state, isLoading: payload};
    case SET_MODULE_DATA:
      return {...state, sampleData: payload};
    case GET_ITEMS_BEING_SAVED:
      return {...state, ...state.test_items_Being_Saved.push(payload)};
    case GET_ITEMS_SAVED:
      return {...state, ...state.test_items_Saved.push(...payload)};
    case GET_UNSAVED_HEADERS:
      return {...state, unsavedHeaderList: payload};
    case SET_SAVE_STATUS:
      return {...state, saveStatus: payload};
    case ERROR:
      return {test_errorMessage: payload};
    default:
      return state;
  }
};
